// Real photos from Instituto ENAGA / Instituto GA+ (provided by user).
export const ENAGA_PHOTOS = {
  autismo: "/uploads/enaga/enaga-autismo.jpg",
  acolhimento: "/uploads/enaga/enaga-acolhimento.jpg",
  atendimento: "/uploads/enaga/enaga-atendimento.jpg",
  oficina: "/uploads/enaga/enaga-oficina.jpg",
  desenvolvimento: "/uploads/enaga/enaga-desenvolvimento.jpg",
  oracaoCristao: "/uploads/enaga/enaga-oracao-cristao.jpg",
  // extended acervo
  alegria: "/uploads/enaga/enaga-alegria.jpg",
  ambiente: "/uploads/enaga/enaga-ambiente.jpg",
  comunhao: "/uploads/enaga/enaga-comunhao.jpg",
  culinaria: "/uploads/enaga/enaga-culinaria.jpg",
  inclusao: "/uploads/enaga/enaga-inclusao.jpg",
  oracaoCirculo: "/uploads/enaga/enaga-oracao-circulo.jpg",
  sorriso: "/uploads/enaga/enaga-sorriso.jpg",
};

// Fallback posts used when Instagram provider is unavailable.
// All images are REAL photos from Instituto GA+ / ENAGA acervo.
const _now = new Date().toISOString();

export const INSTAGRAM_FALLBACK = [
  {
    id: "local-enaga-1",
    profile: "enaga.ga",
    profile_name: "ENAGA Saúde",
    category: "saude",
    media_type: "image",
    media_url: ENAGA_PHOTOS.autismo,
    thumbnail_url: ENAGA_PHOTOS.autismo,
    caption: "02 de abril — Dia Mundial de Conscientização do Autismo. Promovendo inclusão e entendimento em cada atendimento.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/enaga.ga",
    featured: true,
  },
  {
    id: "local-enaga-2",
    profile: "enaga.ga",
    profile_name: "ENAGA Saúde",
    category: "saude",
    media_type: "image",
    media_url: ENAGA_PHOTOS.atendimento,
    thumbnail_url: ENAGA_PHOTOS.atendimento,
    caption: "Atendimento especializado, humanizado e gratuito para cada criança e família.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/enaga.ga",
    featured: false,
  },
  {
    id: "local-enaga-3",
    profile: "enaga.ga",
    profile_name: "ENAGA Saúde",
    category: "saude",
    media_type: "image",
    media_url: ENAGA_PHOTOS.inclusao,
    thumbnail_url: ENAGA_PHOTOS.inclusao,
    caption: "Inclusão não é sobre caber — é sobre pertencer. Aqui cada criança tem seu lugar.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/enaga.ga",
    featured: false,
  },
  {
    id: "local-enaga-4",
    profile: "enaga.ga",
    profile_name: "ENAGA Saúde",
    category: "saude",
    media_type: "image",
    media_url: ENAGA_PHOTOS.ambiente,
    thumbnail_url: ENAGA_PHOTOS.ambiente,
    caption: "Um ambiente seguro, acolhedor e preparado para cuidar do seu filho.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/enaga.ga",
    featured: false,
  },
  {
    id: "local-instituto-1",
    profile: "instituto.ga",
    profile_name: "Instituto GA+",
    category: "social",
    media_type: "image",
    media_url: ENAGA_PHOTOS.oracaoCirculo,
    thumbnail_url: ENAGA_PHOTOS.oracaoCirculo,
    caption: "Antes de qualquer projeto, pessoas. Começamos cada atendimento em oração, por cada família recebida.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/instituto.ga",
    featured: true,
  },
  {
    id: "local-instituto-2",
    profile: "instituto.ga",
    profile_name: "Instituto GA+",
    category: "social",
    media_type: "image",
    media_url: ENAGA_PHOTOS.culinaria,
    thumbnail_url: ENAGA_PHOTOS.culinaria,
    caption: "Oficinas que geram autonomia e futuro: crochê, horta orgânica, corte e costura, culinária.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/instituto.ga",
    featured: false,
  },
  {
    id: "local-instituto-3",
    profile: "instituto.ga",
    profile_name: "Instituto GA+",
    category: "social",
    media_type: "image",
    media_url: ENAGA_PHOTOS.desenvolvimento,
    thumbnail_url: ENAGA_PHOTOS.desenvolvimento,
    caption: "O desenvolvimento começa com educação e cuidado que transformam famílias inteiras.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/instituto.ga",
    featured: false,
  },
  {
    id: "local-instituto-4",
    profile: "instituto.ga",
    profile_name: "Instituto GA+",
    category: "social",
    media_type: "image",
    media_url: ENAGA_PHOTOS.sorriso,
    thumbnail_url: ENAGA_PHOTOS.sorriso,
    caption: "O sorriso de quem foi cuidado com dignidade é o maior indicador de impacto.",
    likes: 0,
    comments: 0,
    posted_at: _now,
    permalink: "https://www.instagram.com/instituto.ga",
    featured: false,
  },
];
